<template>
	<div v-if="isActive" class="logo-container flex-centerize">
		<img v-if="src" :src="src" class="logo-image" />
	</div>
</template>

<script>
export default {
	name: 'WidgetFormLogo',
	props: {
		src: { type: String },
		isActive: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.logo-container {
	width: 50px;
	height: 50px;
	border-radius: 7px;
	background: var(--bg-color);
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);

	.logo-image {
		width: 40px;
		height: 40px;
	}
}
</style>
